import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MassModifyItem } from './mass-modify-item';

@Component({
  selector: 'app-mass-modify',
  templateUrl: './mass-modify.component.html'
})
export class MassModifyComponent {

  @Input() massModifyItems:MassModifyItem[];
  @Input() title:string = "Modifica di massa";
  @Output() choiceButtonMassModify = new EventEmitter<string>();

  clickChoiceButtonMassModify(value: string) {
    if(value != ""){
      this.choiceButtonMassModify.emit(value);
    }
  }

}
